// extracted by mini-css-extract-plugin
module.exports = {"contenedorContacto":"DatosContacto_contenedorContacto__3CJTN"};